import Vue from 'vue';
import { InstanceType } from '../../enums/InstanceType';
import { BoIdMapping } from '../../types/BoIdMapping';

export async function apartmentsLocationsData(context: Vue) {
	const boIdMapping: BoIdMapping = {};

	if (context.$route.query.cityId) {
		boIdMapping[InstanceType.City] = context.$route.query.cityId;
	}

	if (context.$route.query.cityPartId) {
		boIdMapping[InstanceType.CityPart] = context.$route.query.cityPartId;
	}

	return {
		boIdMapping
	};
}
